/** @format */

import { Component, ElementRef, HostBinding, HostListener, Input } from '@angular/core';

@Component({
	// eslint-disable-next-line quotes
	selector: `homefield-button, a[homefield-button], button[homefield-button]`,
	templateUrl: './button.component.html',
	styleUrl: './button.component.scss',
	standalone: false
})
export class HomefieldButtonComponent {
	private ButtonVariants = {
		primary: 'homefield-button-primary',
		secondary: 'homefield-button-secondary',
		tertiary: 'homefield-button-tertiary',
		marketing: 'homefield-button-marketing'
	};

	private ButtonHeights = {
		small: 'small-height',
		base: 'base-height',
		medium: 'medium-height',
		large: 'large-height'
	};

	@Input() variant: string = this.ButtonVariants.primary;
	@Input() height: string = this.ButtonHeights.base;
	@HostBinding('attr.aria-label') @Input() ariaLabel = '';
	@HostBinding('attr.data-test-id') @Input() dataTestId = '';
	@HostBinding('attr.data-em') @Input() dataEm = '';
	@HostBinding('class') @Input() classList = '';

	constructor(private el: ElementRef) {}

	@HostBinding('class') get getVariantApplication() {
		return `${this.classList}${this.classList ? ' ' : ''}${this.getAdditionalCssClass(this.variant, this.height)}`;
	}

	@HostListener('click', ['$event.target'])
	@HostListener('contextmenu', ['$event.target'])
	ignoreMouse(buttonRef: HTMLButtonElement) {
		buttonRef.blur();
	}

	getAdditionalCssClass(variant: string, height: string) {
		return `homefield-button hmf-label-m ${this.ButtonVariants[variant]} ${this.ButtonHeights[height]}`;
	}

	hostClick(): void {
		this.el.nativeElement.click();
	}
}
